import React from 'react';
import { useTranslation } from 'react-i18next';
import MonclerCollectionCheckbox from '@moncler/components/newsletter/MonclerCollectionCheckbox';
const NewsletterSection = (props) => {
    const { t } = useTranslation();
    if (!props.formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "register_form__subtitle mt-16" }, t('register.newsletterchoice')),
        React.createElement("div", { className: "newsletter-flag registration mt-28" },
            React.createElement(MonclerCollectionCheckbox, { formdef: props.formdef, formInstance: props.formInstance }))));
};
export default NewsletterSection;
